import {
  LitElement,
  html,
  css,
  classMap,
  ref,
  createRef,
  map,
  range,
  unsafeHTML,
  styles,
  paths,
  utils,
  t,
} from '@hh/global.js'
const { throttle } = utils

class HHCategoryCarousel extends LitElement {
  static properties = {
    carouselSpeed: {
      type: Number,
      attribute: 'carousel-speed',
    },
    autoplay: {
      type: String,
      attribute: 'autoplay',
    },
  }

  constructor() {
    super()
    this.carouselSpeed = 0
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleCarousel()
  }

  disconnectedCallback() {
    this.splide?.destroy(true)
    this.splide = null

    super.disconnectedCallback()
  }
  handleCarousel() {
    const slider = this.querySelector('.js-category-carousel-slider')

    if (!slider || this.splide) return

    const isAutoplay = this.autoplay === 'true'
    const splideExtension = window.splide?.Extensions

    const breakpoints = isAutoplay
      ? {
          990: {
            perPage: 6,
            padding: '1rem',
          },
          420: {
            perPage: 4,
            padding: '1rem',
          },
          300: {
            perPage: 4,
            padding: '1rem',
          },
        }
      : {
          990: {
            perPage: 6,
            padding: '1rem',
          },
          750: {
            perPage: 4,
            padding: '1rem',
          },
          300: {
            perPage: 4,
            padding: '1rem',
          },
        }

    const options = {
      type: 'slide',
      arrows: true,
      pagination: false,
      rewindSpeed: 1,
      perPage: 6,
      perMove: 1,
      drag: 'free',
      gap: '10px',
      mediaQuery: 'min',
      breakpoints,
    }

    if (isAutoplay) {
      options.autoplay = 'pause'
      options.interval = this.carouselSpeed * 1000
      options.intersection = {
        inView: {
          autoplay: true,
        },
      }
    }

    this.splide = new Splide(slider, options)

    this.splide.on('overflow', (isOverflow) => {
      const arrows = slider.querySelector('.splide__arrows')

      if (!arrows) return

      const display = isOverflow ? '' : 'none'

      if (arrows.style.display !== display) {
        arrows.style.display = display
      }
    })

    if (isAutoplay && splideExtension) {
      this.splide.mount(splideExtension)
    } else {
      this.splide.mount()
    }
  }
  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-category-carousel', HHCategoryCarousel)
